export default {"src":"/_next/static/media/MyNotes.15ddeeb2.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};